import { render, staticRenderFns } from "./vendors-history.vue?vue&type=template&id=7dfb9be0&scoped=true&"
import script from "./vendors-history.vue?vue&type=script&lang=js&"
export * from "./vendors-history.vue?vue&type=script&lang=js&"
import style0 from "./vendors-history.vue?vue&type=style&index=0&id=7dfb9be0&lang=scss&scoped=true&"
import style1 from "./vendors-history.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfb9be0",
  null
  
)

export default component.exports